// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BuyerModule } from '../buyer/buyer.module';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { BuyerDashboardComponent } from './buyer-dashboard/buyer-dashboard.component';
import { BuyerTenantHeaderComponent } from './buyer-tenant-header/buyer-tenant-header.component';
import { BuyerUserHeaderComponent } from './buyer-user-header/buyer-user-header.component';
import { BuyerSideNavComponent } from './buyer-side-nav/buyer-side-nav.component';

@NgModule({
    declarations: [BuyerDashboardComponent, BuyerTenantHeaderComponent, BuyerUserHeaderComponent, BuyerSideNavComponent],
    imports: [BuyerModule, CommonModule, MaterialModule, RouterModule, SharedModule],
    exports: [BuyerTenantHeaderComponent],
})
export class BuyerDashboardModule {}
